import * as Api from '@/helpers/restApi'

export default {
  state: {
    MainBannersData: null,
    MainBannersEducationData: null,
    ShowLoaderBanners: false
  },
  getters: {
    getMainBannersData: state => state.MainBannersData,
    getMainBannersEducationData: state => state.MainBannersEducationData,
    getShowLoaderBanners: state => state.ShowLoaderBanners
  },
  mutations: {
    SetShowLoaderBanners (state, val) {
      state.ShowLoaderBanners = val
    },
    SetMoveBanners (state, val) {
      const swapElements = (array, index1, index2) => {
        const temp = array[index1]
        array[index1] = array[index2]
        array[index2] = temp

        return array
      }
      state.MainBannersData = swapElements(state.MainBannersData, val.newIndex, val.oldIndex)
      this.dispatch('setMoveBanners')
    },
    // мутация для учебного сайта
    SetMoveBannersEducation (state, val) {
      const swapElements = (array, index1, index2) => {
        const temp = array[index1]
        array[index1] = array[index2]
        array[index2] = temp

        return array
      }
      state.MainBannersEducationData = swapElements(state.MainBannersEducationData, val.newIndex, val.oldIndex)
      this.dispatch('setMoveBannersEducation')
    }
  },
  actions: {
    setMainBannersData ({ state, dispatch }) {
      Api.getApi({
        url: '/api/Banners/GetMainPageBanners'
      })
        .then((data) => {
          if (data.Succeeded) {
            state.MainBannersData = data.Data
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    // получить баннеры учебного сайта
    setMainBannersEducationData ({ state, dispatch }) {
      Api.getApi({
        url: '/api/Banner/GetBannersByPageId/1'
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            state.MainBannersEducationData = data.Data
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setSaveBanners ({ state, dispatch }, val) {
      Api.putApi({
        url: '/api/Banners/SaveBanners',
        payload: val
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setMainBannersData', data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    // сохранение загруженных баннеров учебного сайта
    setSaveBannersEducation ({ state, dispatch }, val) {
      Api.putApi({
        url: '/api/Banner/SaveBanners/1',
        payload: val
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setMainBannersEducationData', data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setMoveBanners ({ state, dispatch }, val) {
      Api.putApi({
        url: '/api/Banners/PutForms',
        payload: state.MainBannersData
      })
        .then((data) => {
        })
    },
    // обновить баннеры учебного сайта
    setMoveBannersEducation ({ state, dispatch }, val) {
      Api.putApi({
        url: '/api/Banner/PutForms',
        payload: state.MainBannersEducationData
      }, 'education')
        .then((data) => {
        })
    },
    setClearLoadBanners ({ state, dispatch }, val) {
      Api.putApi({
        url: '/api/Banners/ClearLoadBanners',
        payload: val
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    // очистить загруженные баннеры учебного сайта
    setClearLoadBannersEducation ({ state, dispatch }, val) {
      Api.putApi({
        url: '/api/Banner/ClearLoadBanners',
        payload: val
      }, 'education')
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setDeleteBanner ({ dispatch }, id) {
      Api.deleteApi({
        url: `/api/Banners/Remove/${id}`
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setMainBannersData')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    // удалить баннер учебного сайта
    setDeleteBannerEducation ({ dispatch }, id) {
      Api.deleteApi({
        url: `/api/Banner/RemoveBanner/${id}`
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setMainBannersEducationData')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    }
  }
}
